<template>
  <v-overlay
    :model-value="show"
    class="align-center justify-center"
    scroll-strategy="none"
    persistent
  >
    <v-progress-circular
      :size="size"
      :width="width"
      :indeterminate="indeterminate"
      :color="color"
      :value="value"
      class="egov-progress-spinner"
    />
  </v-overlay>
</template>

<script setup>
defineProps({
  show: {
    type: Boolean,
    default: false
  },
  size: {
    type: [Number, String],
    default: 50
  },
  width: {
    type: [Number, String],
    default: 1
  },
  indeterminate: {
    type: Boolean,
    default: true
  },
  color: {
    type: String,
    default: 'var(--kds-primary)'
  },
  value: {
    type: [Number, String],
    default: 0
  }
})
</script>

<style scoped lang="scss">
.egov-progress-spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  animation: spinnerFadeIn 0.3s ease-in-out;

  @keyframes spinnerFadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
}
</style>
